import { createContext, useContext } from "react";
import useAxios from "../Utils/useAxios";
import { getItemCreateSuccessMsg } from "../Constant/Message";
import { openPdfInNewTab } from "../Utils/otherFunctions";
import { handleError, handleSuccess } from "../Utils/externalFunctions";

const SlipGajiContext = createContext();

export const useSlipGaji = () => useContext(SlipGajiContext);

export const SlipGajiProvider = ({ children }) => {
  const axiosInstance = useAxios();

  const api = {
    postSlipGajiPreview: (formData, setPending = null) =>
      axiosInstance
        .post("slipgaji/preview/", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) =>
          handleSuccess(res, getItemCreateSuccessMsg("Preview Slip Gaji"))
        )
        .catch((err) => {
          if (setPending) setPending(false);
          return handleError(err, "POST Slip Gaji");
        }),

    postSlipGaji: (formData) =>
      axiosInstance
        .post("slipgaji/cetak/", formData, {
          responseType: "blob",
        })
        .then((res) => {
          openPdfInNewTab(res);
          return handleSuccess(res, getItemCreateSuccessMsg("Slip Gaji"));
        })
        .catch((err) => handleError(err, "POST Slip Gaji")),

    postSlipGajiEmail: (formData) =>
      axiosInstance
        .post("slipgaji/email/", formData)
        .then((res) => handleSuccess(res, getItemCreateSuccessMsg("Slip Gaji")))
        .catch((err) => handleError(err, "POST Email Slip Gaji")),
  };

  return (
    <SlipGajiContext.Provider value={api}>{children}</SlipGajiContext.Provider>
  );
};

export default SlipGajiContext;
